/**
 * The second factor, as the sign-in screen sees it.
 *
 * Which factor an account uses is decided by the backend, not here - a user with
 * a passkey is never offered an emailed code. The client's job is to present
 * whichever challenge it is handed and send the answer back.
 */

import type { PublicKeyCredentialRequestOptionsJSON } from "@simplewebauthn/browser";

export type FactorChallenge =
  | { method: "email"; mfaToken: string; sent: boolean }
  | {
      method: "passkey";
      handle: string;
      options: PublicKeyCredentialRequestOptionsJSON;
    };

/**
 * Thrown by `login` when the password was accepted and a factor is now owed.
 *
 * A distinct type rather than a message, because this is not a failed sign-in:
 * treating it as one would show the user "invalid credentials" for a password
 * that was in fact correct.
 */
export class SecondFactorRequiredError extends Error {
  readonly challenge: FactorChallenge | null;

  constructor(message: string, challenge: FactorChallenge | null) {
    super(message);
    this.name = "SecondFactorRequiredError";
    this.challenge = challenge;
  }
}

/** What the client posts back as `factor` for the passkey path. */
export function assertionFactor(handle: string, response: unknown): string {
  return JSON.stringify({ handle, response });
}
